import { Factory } from 'miragejs';

// Mirage-only Data Factory
// Helps simulate the ActiveStorage / Direct Upload endpoints.
// This factory builds data that is server-side / payload only.
// It is not consumed by Ember Data.

export default Factory.extend({
  key() {
    // Just a random string
    return parseInt(Math.random() * Date.now(), 10).toString(32);
  },

  signed_id() {
    // Just a random string
    return parseInt(Math.random() * Date.now(), 10).toString(32);
  },

  metadata() {
    return {};
  },

  created_at() {
    return new Date().toJSON();
  },

  filename: '',
  content_type: '',
  byte_size: 0,
  checksum: '',

  direct_upload() {
    return {
      url: `/s3/bucket/envoy-development/${this.key}`,
      headers: {
        'Content-Type': this.content_type,
        'Content-MD5': this.checksum,
      },
    };
  },
});
